module.exports = __webpack_public_path__ + "img/公益风采.da966de7.png";